import { parseCookies } from '@cian/utils';

import { SESSION_MY_HOME_HOMEOWNER_TRAP_KEY } from './constants';

export const getCloseFromCookie = () => {
  return parseInt(parseCookies(document.cookie)[SESSION_MY_HOME_HOMEOWNER_TRAP_KEY], 10);
};
